module.exports = "/images/shoppingCar.svg";